module.exports = Object.freeze({
    EMAIL_SETTING: "Cấu hình e-mail",
    GENERAL_SETTING: "Cấu hình chung",
    FROM_EMAIL: "Địa chỉ Email gửi",
    FROM_NAME: "Tên người gửi",
    PORT: "Cổng",
    HOST: "Host",
    SMTP_AUTHENTICATION: "Xác thực SMTP",
    PASSWORD: "Mật khẩu",
    SAVE: "Lưu cấu hình",
    SEND_EMAIL_TEST: "Gửi Email mẫu",
    PROXY:"Proxy",
    TLS:"TLS",
    SECURITY_NONE:"Không mã hóa",
    SECURITY:"Phương thức mã hóa",
    SERVER_EMAIL : "Chọn máy chủ",
    CUSTOM:"CUSTOM",
    SMTP:"SMTP",
    SERVICE: "Service",
    GMAIL:"Gmail",
    ZOHO:"Zoho",
    EXIT: "Thoát",
    INPUT_ERROR:"Thông tin nhập không chính xác",
    NO_RESULTS: 'Không có kết quả phù hợp',
    NO_DATA: 'Không có dữ liệu',
    NUMBER_ITEMS: "Số phần tử",
    SEND_TO: "Gửi đến",
    MAILCC: "Mail CC",
    TITLE_EMAIL: "Tiêu đề",
    CONTENT: "Nội dung",
    NO_EMAIL: 'Chưa nhập Email cần gửi',
    NO_EMAIL_OR_ERROR: 'Chưa nhập hoặc không đúng định dạng Email',
    VALIDATE_EMAIL_FAIL: 'Định dạng Email không đúng',
    SENDFROM_ERROR: 'Tên người gửi phải dài từ 0 đến 50 ký tự',
    PASSWORD_ERROR: 'Mật khẩu phải dài từ 6 đến 20 ký tự',
    EMPTY_ERROR: 'Không được để trống'
});